import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import {log, logModel} from "../../model/logsModel"
import * as moment from 'moment';
import {personModel, statsRecord} from "../../model/personModel"

@Component({
  selector: 'page-show-activity-logs',
  templateUrl: 'show-activity-logs.html'
})
export class ShowActivityLogsPage {
    events: any;
    constructor(
        public navCtrl: NavController,
        public navParams: NavParams,
        public logModel: logModel,
        public statsRecord: statsRecord
    ) {
        var dat = moment(new Date());
        this.events = logModel.getData('',dat.year(),dat.month()+1,dat.week()); 
    }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ShowActivityLogsPage');
    }
  edit() {

  }
  deleteItem(obj: log) {
      var dir = -1;
      this.statsRecord.addTo('year', obj.year, obj.event, obj.milage*dir);
      this.statsRecord.addTo('month', obj.month, obj.event, obj.milage * dir);
      this.statsRecord.addTo('week', obj.week, obj.event, obj.milage*dir);
      this.logModel.delete(obj);
  }

}



// WEBPACK FOOTER //
// ./src/pages/show-activity-logs/show-activity-logs.ts